// import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
import Router from './routes/Router';
import './app.css';

const App = () => {

  const routing = useRoutes(Router);

  return (
    <div>
        {routing}
    </div>
  )
}

export default App;
